<div class="container">
    <div *ngIf="welcomeText != null">
        <quill-view [content]="welcomeText"></quill-view>
    </div>
    <div class="col-md-12" *ngIf="alert">
        <div class="alert" [ngClass]="{'alert-success' : alert.type === 'success', 'alert-danger': alert.type === 'danger' }" role="alert">
            {{alert.msg}}
            <button type="button" class="close" (click)="closeAlert()">
                <i class="modus-icons">close</i>
            </button>
        </div>
    </div>
    <div class="card" style="box-shadow: 0 1px 1px rgb(0 0 0 / 5%);">
        <div class="row card-body">
            <div class="col-md-3">
            </div>
            <form #welcomeForm="ngForm" class="col-md-6" ngbAutofocus>
                <div style="margin-bottom: 10px;">
                    <label class="control-label"><strong>First Name:</strong></label>
                    <input name="firstname" [(ngModel)]="formData.firstName" type="text" class="form-control" [required]="true" />
                </div>
                <div style="margin-bottom: 10px;">
                    <label class="control-label"><strong>Last Name:</strong></label>
                    <input name="lastname" [(ngModel)]="formData.lastName" type="text" class="form-control" [required]="true" />
                </div>
                <div *ngIf="!userNoPIN" style="margin-bottom: 10px;">
                    <label class="control-label"><strong>{{labelForOnboardingPIN}}:</strong></label>
                    <input name="onboardingPIN" type="text" class="form-control" [(ngModel)]="formData.onboardingPIN" [required]="true" />
                </div>
                <div *ngIf="userNoPIN && !removeEmailFromOnboardEnroll" style="margin-bottom: 10px;">
                    <label class="control-label"><strong>Email:</strong></label>
                    <input name="email" type="email" class="form-control" [(ngModel)]="formData.email" [required]="!removeEmailFromOnboardEnroll" />
                </div>
                <div *ngIf="userNoPIN && allowUserProfileSelection && !profilePreBound" style="margin-bottom: 10px;">
                    <label class="control-label"><strong>Hiring Location</strong></label>
                    <ng-select name="OnboardLocationName"
                               [ngClass]="{'is-invalid' : !formData.OnboardLocationID}"
                               [searchable]="false"
                               [(ngModel)]="formData.OnboardLocationID"
                               bindLabel="OnboardLocationName"
                               (change)="updateProfile()"
                               [clearable]="false"
                               dropdownPosition="bottom"
                               [required]="true">
                        <ng-option *ngFor="let data of locationList" [value]="data.OnboardLocationID">{{data.OnboardLocationName}}</ng-option>
                    </ng-select>
                </div>
                <div *ngIf="userNoPIN && allowUserProfileSelection && !profilePreBound" style="margin-bottom: 10px;">
                    <label class="control-label"><strong>{{labelForProfileDropdown}}:</strong></label>
                    <ng-select name="OnboardProfileName"
                               [ngClass]="{'is-invalid' : !formData.profile}"
                               id="focusSelect"
                               [searchable]="false"
                               [(ngModel)]="formData.profile"
                               [clearable]="false"
                               dropdownPosition="bottom"
                               [required]="true"
                               [disabled]="formData.OnboardLocationID == null">
                        <ng-option *ngFor="let profile of profiles" [value]="profile">{{profile.OnboardProfileName}}</ng-option>
                    </ng-select>
                </div>
                <br />
                <div style="text-align: center">

                    <button class="btn btn-outline-dark" *ngIf="!userNoPIN" [disabled]="welcomeForm.form.invalid" (click)="continue()">
                        Continue
                    </button>

                    <button class="btn btn-outline-dark" *ngIf="userNoPIN" [disabled]="welcomeForm.form.invalid" (click)="continue()">
                        Begin
                    </button>

                    <span class="button-link" *ngIf="!userNoPIN && enablePINRequest">
                        <a (click)="noPIN()" style="cursor: pointer;">I don't have a PIN</a>
                    </span>

                    <span class="button-link" *ngIf="userNoPIN && enablePINRequest">
                        <a (click)="yesPIN()" style="cursor: pointer;">
                            I have a PIN
                        </a>
                    </span>
                </div>
            </form>
        </div>
    </div>
</div>